import { environment } from "../../environment";
import { io } from 'socket.io-client';
const socketHost = environment.msgUrl;

export const socket = io(
    socketHost,
    {
        path :'/notifications',
        transports: ['polling']
});


export const MsgService = () => {

    const connectToSocketServer = async () => {
        try {
        } catch (err) {
            throw err;
        }
    };


    return {
        connectToSocketServer,
    };


};